import { render } from "./AddedPromptElement.vue?vue&type=template&id=686496cf&scoped=true&ts=true"
import script from "./AddedPromptElement.vue?vue&type=script&lang=ts"
export * from "./AddedPromptElement.vue?vue&type=script&lang=ts"

import "./AddedPromptElement.vue?vue&type=style&index=0&id=686496cf&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686496cf"]])

export default __exports__